import { Routes } from '@angular/router';

import { CanActivateViaAdminGuard } from './route-guards/can-activate-via-admin-guard';
import { UnderConstructionComponent } from './components/under-construction';
import { AdminComponent } from './admin.component';
import { LayoutComponent } from './components/layout';

export const ROUTES: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'login',
        loadChildren: './modules/+login#LoginModule'
      },
      {
        path: 'file-manager',
        loadChildren: './modules/+file-manager#FileManagerModule'
      },
      {
        path: '',
        component: LayoutComponent,
        canActivate: [ CanActivateViaAdminGuard ],
        data: {
          title: "admin.dashboard"
        },
        children: [
          {
            path: '',
            redirectTo: 'page-list',
            pathMatch: 'full'
          },
          {
            path: 'dashboard',
            data: {
              title: 'admin.dashboard'
            },
            loadChildren: './modules/+dashboard#DashboardModule'
          },
          {
            path: 'user-list',
            data: {
              title: 'admin.users'
            },
            loadChildren: './modules/+user#UserModule'
          },
          {
            path: 'category-list',
            data: {
              title: 'admin.categories'
            },
            loadChildren: './modules/+category#CategoryModule'
          },
          {
            path: 'page-list',
            data: {
              title: 'admin.pages'
            },
            loadChildren: './modules/+page#PageModule'
          },
          {
            path: 'banner-list',
            data: {
              title: 'admin.banners'
            },
            loadChildren: './modules/+banner#BannerModule'
          },
          {
            path: 'expertise-list',
            data: {
              title: 'admin.expertise'
            },
            loadChildren: './modules/+expertise#ExpertiseModule'
          },
          {
            path: 'network-list',
            data: {
              title: 'admin.networks'
            },
            loadChildren: './modules/+network#NetworkModule'
          },
          {
            path: 'strength-list',
            data: {
              title: 'admin.strengths'
            },
            loadChildren: './modules/+strength#StrengthModule'
          },
          {
            path: 'job-list',
            data: {
              title: 'admin.jobs'
            },
            loadChildren: './modules/+job#JobModule'
          },
          {
            path: 'offer-list',
            data: {
              title: 'admin.offers'
            },
            loadChildren: './modules/+offer#OfferModule'
          },
          {
            path: 'location-list',
            data: {
              title: 'admin.locations'
            },
            loadChildren: './modules/+location#LocationModule'
          },
          {
            path: 'menu-list',
            data: {
              title: 'admin.menus'
            },
            loadChildren: './modules/+menu#MenuModule'
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/admin.routes.ts